<p-dialog [(visible)]="visible" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__case">
          <span>CASO 300-200</span>
        </div>

        <div class="dialog__icon dialog__icon--error pb-15">
          <span>
            <app-alert-simple-icon></app-alert-simple-icon>
          </span>
        </div>

        <div class="dialog__info dialog__info--error">
          <h2>IMEI ya registrado</h2>
          <p>
            El IMEI esta siendo usado en la solicitud <strong>PAF-BAGRAER</strong> que pertenece al cliente: 
            <br>
            <strong>MIGUEL HERNANDEZ SILVA</strong>.
          </p>
        </div>

        <div class="dialog__text pt-20">
          <div class="errorMsg">
            <p>¿Deseas cancelar esa solicitud y continuar con ésta?</p>
          </div>
        </div>

        <div class="dialog__btn dialog__btn--gap">
          <!-- PRIMARY BUTTON 1 -->
          <div class="item" *ngIf="true">
            <button pButton pRipple label="Volver a ingresar el IMEI" icon="pi pi-angle-left" iconPos="left" class="p-button-primary p-button-raised p-button-rounded n-border w-full"></button>
          </div>

          <!-- PRIMARY BUTTON 2 -->
          <div class="item" *ngIf="false">
            <button pButton pRipple label="Reintentar" icon="pi pi-refresh" iconPos="left" class="p-button-primary p-button-raised p-button-rounded n-border w-full"></button>
          </div>

          <!-- SECONDARY BUTTON 1 -->
          <div class="item" *ngIf="false">
            <button pButton pRipple label="Cambiar Enrolamiento" icon="pi pi-angle-right" iconPos="right" class="p-button-secondary p-button-raised p-button-rounded w-full"></button>
          </div>

          <!-- TEXT BUTTON 1 -->
          <div class="item" *ngIf="true">
            <p-button label="Cancelar solicitud" [text]="true" [plain]="true"></p-button>
          </div>

          <!-- TEXT BUTTON 2 -->
          <div class="item" *ngIf="false">
            <p-button label="Cancelar solicitud de [NOMBRE CLIENTE]" [text]="true" [plain]="true"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
